// Carries a ?directory_claim=<uuid> param from a Car Wrap Shops (carwrapshops.com)
// claim link through signup, email verification and onboarding - whichever
// page the link lands on - so it survives to link-up once the user has an
// active workspace. See docs/DIRECTORY_SPEC.md ("Quote -> WrapForce lead").
const STORAGE_KEY = 'wf-directory-claim';
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// Call once at app start (client/src/main.tsx). Reads directory_claim from
// the current URL and, if it looks like a uuid, stashes it in localStorage.
export function captureDirectoryClaimFromUrl(): void {
  const token = new URLSearchParams(window.location.search).get('directory_claim');
  if (token && UUID_RE.test(token)) {
    localStorage.setItem(STORAGE_KEY, token);
  }
}

// Non-destructive check used by SignupPage/LoginPage to show a short notice.
export function hasDirectoryClaim(): boolean {
  return !!localStorage.getItem(STORAGE_KEY);
}

// Reads and clears the stored token. Destructive so the link attempt below
// can only ever fire once per token.
export function takeDirectoryClaim(): string | null {
  const token = localStorage.getItem(STORAGE_KEY);
  if (token) localStorage.removeItem(STORAGE_KEY);
  return token;
}
